<template lang="pug">
  .col-24.initBackgroundImage.flexD.alignItemsCenter.justifyCenter.l-padding-top-4em.l-padding-bottom-4em.m-backgroundSizeCover(:style="{backgroundImage:'url('+ img.bg +')', backgroundPosition: 'top'}")
    .col-12.flexD.flexDirectionColumn.minWidth700.m-minWidthAuto.m-width-90
      .col-24.flexD.justifyCenter.l-margin-bottom-4em.m-margin-bottom-2em
        .col-6.m-width-40
          img.col-24.block(:src="img.logo")
      .col-24
        .font-section.textAlignLeft {{ des }}


</template>

<script>
  export default {
    name: 'pressalit',
    props: ['content'],
    data(){
      return{
        des: this.$t('pressalit.content'),
        img: {
          logo: require('@/assets/img/logo/logo_pressalit.png'),
          bg: require('@/assets/img/bg_pressalit.png'),
        },
      }
    },
    computed: {},
    methods:{},
    created(){}
  }
</script>
